export default __webpack_public_path__ + "static/media/dove.9924536b.jpg";